import template from './sw-cms-el-preview-sidebar-filter.html.twig';
import './sw-cms-el-preview-sidebar-filter.scss';

/**
 * @private
 * @package buyers-experience
 */
export default {
    template,
};
